import { AccountResponse } from '../../models/account/AccountResponse';
import { t } from 'i18next';
import { canShowModel } from '../../utils/utils';

export type ChatType =
  | 'ALL'
  | 'GPT'
  | 'GPT_SEARCH'
  | 'GPT_BROWSER'
  | 'GEMINI'
  | 'CLAUDE'
  | 'DEEP_SEEK'
  | 'PERPLEXITY'
  | 'PERPLEXITY_BROWSER'
  | 'GROK'
  | 'GROK_BROWSER'
  | 'AI_OVERVIEW_BROWSER'
  | 'AI_OVERVIEW_NEW_BROWSER'
  | 'AI_MODE_BROWSER'
  | 'COPILOT_BROWSER'
  | 'GEMINI_BROWSER';
export const projectChatType = (
  accountResponse: AccountResponse | null,
  ignoreAdmin = false,
  ignoreBrowserChat = false
) => {
  if (!accountResponse) {
    return ['GPT', 'GEMINI', 'CLAUDE', 'DEEP_SEEK', 'PERPLEXITY'];
  }

  const options = [];
  const features = accountResponse.features;

  options.push('GPT');

  if (
    canShowModel('GEMINI', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('GEMINI');
  }

  if (
    canShowModel('CLAUDE', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('CLAUDE');
  }

  if (
    canShowModel('DEEP_SEEK', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('DEEP_SEEK');
  }

  if (
    canShowModel('PERPLEXITY', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('PERPLEXITY');
  }

  if (
    canShowModel('GROK', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('GROK');
  }

  if (
    canShowModel('AI_MODE', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('AI_MODE_BROWSER');
  }

  if (
    canShowModel('AI_OVERVIEW_NEW', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('AI_OVERVIEW_NEW_BROWSER');
  }

  if (
    canShowModel('COPILOT', features) ||
    (accountResponse.isSuperAdmin && !accountResponse.isLimitedSuperAdmin && !ignoreAdmin)
  ) {
    options.push('COPILOT_BROWSER');
  }

  return options;
};

export const getChatTypeToName = (chatType: ChatType): string => {
  switch (chatType) {
    case 'GPT':
      return t('gptName');

    case 'GPT_BROWSER':
      return t('gptSearchName');

    case 'GPT_SEARCH':
      return t('gptSearchName');

    case 'CLAUDE':
      return t('claudeName');

    case 'GEMINI':
      return t('geminiName');

    case 'DEEP_SEEK':
      return t('deepSeekName');

    case 'PERPLEXITY_BROWSER':
    case 'PERPLEXITY':
      return t('perplexityName');

    case 'GROK':
    case 'GROK_BROWSER':
      return t('grokSearchName');

    case 'AI_OVERVIEW_NEW_BROWSER':
      return t('aiOverviewName');

    case 'AI_MODE_BROWSER':
    case 'AI_OVERVIEW_BROWSER':
      return t('aiModeName');

    case 'COPILOT_BROWSER':
      return t('copilotSearchName');

    case 'GEMINI_BROWSER':
      return t('geminiSearchName');

    default:
      return t('all');
  }
};
